<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  >
    <div class="pb24 dt-mb64" v-if="dynamicBannerOffers.length">
      <div
        class="dynamic-banner-carousel"
        ref="carouselTrack"
        @scroll.passive="handleCarouselScroll"
      >
        <div
          class="dynamic-banner-carousel-slide"
          v-for="item in dynamicBannerOffers"
          :key="item?.id"
          ref="slideRefs"
        >
          <div
            class="horizontal-carousel pr"
            :style="{
              background: item?.attributes?.backgroundGradient,
            }"
          >
            <hero-banners
              :data-title="item.title"
              :data-subTitle="item.subTitle"
              :data-ctaText="item.attributes?.ctaText"
              :data-banner-img="item.logo"
              :data-img-bg="item.imgBig"
              :data-justify-img-content="item.attributes?.justifyImgContent"
              :data-title-color="item.attributes?.titleColor"
              :data-subTitle-color="item.attributes?.subTitleColor"
              :data-actionButton-color="item.attributes?.actionButtonColor"
              :data-actionButton-background="
                item.attributes?.actionButtonBackground
              "
              :data-img-left="item.attributes?.imgPositionLeft"
              :data-img-width="'auto'"
              :data-img-height="item.attributes?.bannerImgHeight"
              :data-text-align="item.attributes?.textAlign"
              :data-img-opacity="item.attributes?.imgOpacity"
              :data-banner-border-radius="item.attributes?.bannerImgRadius"
              :data-banner-img-style="
                !item.imgBig ? 'herobanner-img-wrap' : 'herobanner-img-bg'
              "
              :data-action="item.mobileLinkRewrite"
              :data-coupon="item.couponCode"
            >
            </hero-banners>
          </div>
        </div>
      </div>
      <ul
        class="dynamic-banner-pagination"
        v-if="dynamicBannerOffers.length > 1"
      >
        <li
          class="dynamic-banner-pagination-item"
          v-for="(item, index) in dynamicBannerOffers"
          :key="item?.id"
        >
          <button
            type="button"
            class="dynamic-banner-pagination-dot"
            :class="{
              'dynamic-banner-pagination-dot--active':
                index === activeSlideIndex,
            }"
            @click="goToSlide(index)"
            :aria-label="`Go to slide ${index + 1}`"
          ></button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { clientPlatform } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";

export default {
  name: "HorizontalCarousel",
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      clientPlatform,
      sessionDependedMethodsProcessed: false,
      modulePropsData: {},
      dynamicBannerOffers: [],
      activeSlideIndex: 0,
      scrollDebounceTimer: null,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    let deliveryType = LocalStorageFunc.getDeliveryType();
    let banners = JSON.parse(this.dataResults) || [];
    this.dynamicBannerOffers = banners.filter((item) => {
      let orderType = item?.orderType;
      if (!orderType) return true;
      return orderType
        .split(",")
        .map((type) => type.trim().toLowerCase())
        .includes(deliveryType.toLowerCase());
    });
  },
  methods: {
    handleCarouselScroll() {
      clearTimeout(this.scrollDebounceTimer);
      this.scrollDebounceTimer = setTimeout(() => {
        const container = this.$refs.carouselTrack;
        const slides = this.$refs.slideRefs;
        if (!container || !slides?.length) return;

        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const scrollEndThreshold = 2;

        if (container.scrollLeft <= scrollEndThreshold) {
          this.activeSlideIndex = 0;
          return;
        }
        if (container.scrollLeft >= maxScrollLeft - scrollEndThreshold) {
          this.activeSlideIndex = slides.length - 1;
          return;
        }

        const containerCenter =
          container.scrollLeft + container.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(slideCenter - containerCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.activeSlideIndex = closestIndex;
      }, 100);
    },
    goToSlide(index) {
      const container = this.$refs.carouselTrack;
      const slide = this.$refs.slideRefs?.[index];
      if (!container || !slide) return;

      container.scrollTo({
        left:
          slide.offsetLeft - (container.clientWidth - slide.offsetWidth) / 2,
        behavior: "smooth",
      });
      this.activeSlideIndex = index;
    },
  },
  computed: {
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP && !this.sessionDependedMethodsProcessed) {
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
  },
};
</script>
